function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class TierAward extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
  }
  
  connectedCallback() {
    this.updateAriaExpanded();
    const showMoreBtn = this.querySelector('.tier-award-show__btn');
    showMoreBtn.addEventListener('click', () => this.toggleExpand());

    window.addEventListener('resize', () => {
      this.updateAriaExpanded();
    });
  }
  updateAriaExpanded() {
    const isMobile = window.innerWidth < 989;
    const header = this.querySelector('.tier-award__header');
    const footer = this.querySelector('.tier-award__footer');
    header.setAttribute('aria-expanded', !isMobile);
    footer.setAttribute('aria-expanded', !isMobile);
    
    // If expanding on desktop, show the elements
    if (!isMobile && this.isExpanded) {
      const productOffer = this.querySelector('.tier-award-product-offer');
      const progressBar = this.querySelector('.tier-award-progress');
      productOffer.style.display = 'flex';
      progressBar.style.display = 'block';
    }
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
    const showMoreBtn = this.querySelector('.tier-award-show__btn');
    const productOffer = this.querySelector('.tier-award-product-offer');
    const progressBar = this.querySelector('.tier-award-progress');
    const header = this.querySelector('.tier-award__header');
    const footer = this.querySelector('.tier-award__footer');
    const chevonArrow = this.querySelector('.tier-award-btn__arrow');

    if (this.isExpanded) {
      showMoreBtn.textContent = 'Show Less';
      productOffer.style.display = 'flex';
      progressBar.style.display = 'block';
      progressBar.style.transition = 'display 0.3ms ease-in-out';
      productOffer.style.transition = 'display 0.3ms ease-in-out';
      chevonArrow.style.transform = 'rotate(-45deg)';
      chevonArrow.style.transition = 'transform 0.3ms ease-in-out';
      chevonArrow.style.marginBottom = '0px';
      header.setAttribute('aria-expanded', true);
      footer.setAttribute('aria-expanded', true);
      header.style.display = "block";
      footer.style.display = "block";
    } else {
      showMoreBtn.textContent = 'Show More';
      productOffer.style.display = 'none';
      productOffer.style.transition = 'display 0.3ms ease-in-out';
      progressBar.style.transition = 'display 0.3ms ease-in-out';
      progressBar.style.display = 'none';
      chevonArrow.style.marginBottom = '15px';
      chevonArrow.style.transform = 'rotate(135deg)';
      header.setAttribute('aria-expanded', false);
      footer.setAttribute('aria-expanded', false);
      header.style.display = "none";
      footer.style.display = "none";
    }
  }
}

customElements.define('tier-award', TierAward);

const triggerButton = document.querySelectorAll('.add_to_cart');
const removeButtons = document.querySelectorAll('.remove-icon');



document.body.addEventListener('click', function(event) {
  if (event.target && event.target.classList.contains('remove-icon')) {
    setTimeout(() => {
      updateTierPrice();
    }, 400);
  }
  if ((event.target && event.target.classList.contains('icon-plus')) || event.target.classList.contains('product-plus')) {
    console.log('plus clicked');
    setTimeout(() => {
      updateTierPrice();
    }, 400);
  }
  if ((event.target && event.target.classList.contains('icon-minus')) || event.target.classList.contains('product-minus')) {
    console.log('minus clicked');
    setTimeout(() => {
      updateTierPrice();
    }, 400);
  }
});

let unlockedTiers = [];
console.log(unlockedTiers);
triggerButton.forEach((button) => {
  button.addEventListener('click', () => {

    setTimeout(() => {
      document.body.classList.remove('blocked-scroll');
      updateTierPrice();
    }, 1000);
  });
});

function updateTierPrice() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(async cart => {
      const items = (await Promise.all(cart.items.map(async item => {
        const url = `/products/${item.handle}.js`;
        const cardProduct = await (await fetch(url)).json();
        if(cardProduct) {
          return {
            ...item,
            ...cardProduct
          }
        }
        return undefined;
      }))).filter(item => item !== undefined && item.tags.includes('bms-noMotivate') === false);

      const totalPrice = items.reduce((total, item) => {
        if (!item.tags.includes('bms-noMotivate')) {
          return total + item.line_price;
        }
        return total;
      }, 0);

      const cartValue = totalPrice;
      const bodyElement = document.querySelector('body');
      const moneyFormat = bodyElement.getAttribute('data-money-format');
     // const tierMoneyMobile = document.querySelector('.tier-award__money-mobile .tier-award__total');
     // const tierMoneyDesktop = document.querySelector('.tier-award__money-desktop .tier-award__total');
      const tier1 = document.querySelector('.tier-award-product.tier-1')
      const tier1Id = tier1 ? tier1.querySelector('.tier-award-offer__options').getAttribute('offer-id') : null;
      const tier2 = document.querySelector('.tier-award-product.tier-2')
      const tier2Id = tier2 ? tier2.querySelector('.tier-award-offer__options').getAttribute('offer-id') : null;
      const tier3 = document.querySelector('.tier-award-product.tier-3')
      const tier3Id = tier3 ? tier3.querySelector('.tier-award-offer__options').getAttribute('offer-id') : null;
      const priceThreshold = parseFloat(document.querySelector('.tier-award-progress__container').getAttribute('data-threshold'));

     // tierMoneyMobile.innerHTML = formatMoney(cartValue, moneyFormat);
      //tierMoneyDesktop.innerHTML = formatMoney(cartValue, moneyFormat);
      
      let totalPriceNew = Math.round(cartValue / 100);
      const tierOneThreshold = window.tier_one_threshold;
      const tierTwoThreshold = window.tier_two_threshold;
      const tierThreeThreshold = window.tier_three_threshold;
      
      const tierOneLimit = 33;
      const tierTwoLimit = 50; 
      const tierThreeLimit = 100; 
      

      const minimumProgress = 5; 

      let progressPercent = 0;
      if (totalPriceNew >= tierThreeThreshold) {
        progressPercent = tierThreeLimit;
      } else if (totalPriceNew >= tierTwoThreshold) {
        progressPercent = tierTwoLimit;
      } else if (totalPriceNew >= tierOneThreshold) {
        progressPercent = tierOneLimit;
      } else {

        progressPercent = totalPriceNew > 0 ? minimumProgress : 0;
      }


      progressPercent = Math.min(progressPercent, 100);

      const progressBar = document.querySelector('.tier-award-progress__bar');
      progressBar.style.width = `${progressPercent}%`;
      
      // window.tier_one_threshold etc can be found in theme.liquid before the </body>
      const tiers = [
        tier1 && {
          element: tier1,
          minPrice: window.tier_one_threshold,
          subheadingText: 'Congratulations',
          offerText: 'Unlocked',
          offerTextDefault: 'Spend $50+',
          subHeadingDefault: 'UNLOCK',
          id: tier1Id
        },
        tier2 && {
          element: tier2,
          minPrice: window.tier_two_threshold,
          subheadingText: 'Congratulations',
          offerText: 'Unlocked',
          offerTextDefault: 'Spend $100+',
          subHeadingDefault: 'UNLOCK',
          id: tier2Id
        },
        tier3 && {
          element: tier3,
          minPrice: window.tier_three_threshold,
          subheadingText: 'Congratulations',
          offerText: 'Unlocked',
          offerTextDefault: 'Spend $150+',
          subHeadingDefault: 'UNLOCK',
          id: tier3Id
        }
      ].filter(Boolean); // Remove null entries

      const toAdd = [];
      const toRemove = [];

      for(let i = 0; i < tiers.length; ++i) {
        const tier = tiers[i];
        if(totalPriceNew >= tier.minPrice) {
          if(!items.find((i) => i.variant_id == tier.id) && !toAdd.includes(tier.id)){
            toAdd.push(tier.id); // wat i see nothing can be done? it can be lol, by preventing multiple calls
          }
          if(tier.element) {
            tier.element.querySelector('.tier-award-product__subheading p').textContent = tier.subheadingText; 
            tier.element.querySelector('.tier-award-product__offer span').textContent = tier.offerText;
            tier.element.classList.add('unlocked');
          }
        } else if(totalPriceNew < tier.minPrice) {

          if(items.find(i => i.variant_id == tier.id)){
            toRemove.push(tier.id);
          }
          if(tier.element) {
            tier.element.classList.remove('unlocked');
            tier.element.querySelector('.tier-award-product__subheading p').textContent = tier.offerText; 
            tier.element.querySelector('.tier-award-product__offer span').textContent = tier.offerTextDefault;
          }
        } else {
          if(tier.element) {
            tier.element.classList.remove('unlocked');
            tier.element.querySelector('.tier-award-product__subheading p').textContent = tier.offerText; 
            tier.element.querySelector('.tier-award-product__offer span').textContent = tier.offerTextDefault;
          }
        }
      }  
      toAdd.length > 0 && await addToCart(toAdd, 1);
      toRemove.length > 0 && await removeFromCart(toRemove, 0);
    });
}

async function removeFromCart(ids, quantity) {
  try {
    let formData = {
      updates: {}
    }
    ids.forEach(id => {
      formData.updates[id] = quantity;
    });

    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if(res.status === 200) {
      const data = await res.json();
      refreshCart(data);
    }

  } catch (err) {
    console.log(err);
  }
}

async function addToCart(ids, quantity) {
  const itemIdQ = ids.map(id => {
    return {
      id,
      quantity
    }
  }); 

  try{
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: itemIdQ
      })
    });

    if(res.status === 200) {
      const data = await (await fetch('/cart.js')).json();
      refreshCart(data);
    }

  }catch(err){
    console.log(err);

  }
}

// on page load update the tier price and progress bar width 
document.addEventListener('DOMContentLoaded', () => {
  updateTierPrice();
});
